import React from 'react';
function ExpandMore() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })));
}
export default ExpandMore;
